import '../App.css';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { useNavigate, useLocation } from 'react-router-dom';
import { AnyAction } from 'redux';
import * as UI from '../slices/uiSlice';
import * as Quotes from '../slices/quotesSlice';
import * as Forms from '../slices/formsSlice';
import icon_home from '../assets/Home_White.svg';
import icon_mainhub from '../assets/MainHub_White.svg';
import icon_quote from '../assets/Quote_White.svg';
import icon_instruct from '../assets/Instruct_White.svg';
import icon_wishlist from '../assets/Wishlist_White.svg';
import icon_analytics from '../assets/Analytics_White.svg';
import icon_edit_chart from '../assets/edit-chart-icon.svg';
import icon_logout from '../assets/Logout_White.svg';

const NavMenu = () => {
	const uiState = useAppSelector(state => state.ui);
	const location = useLocation();
	const quotes = useAppSelector(state => state.quotes);
	const cases = useAppSelector(state => state.cases);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const clickItem = (loc: string) => {
		const closeMenu = () => new Promise((resolve) => resolve(dispatch((UI.closeMenu()) as unknown as AnyAction)));
		if (loc == "/quote") {
			const removequoteform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("QF")) as unknown as AnyAction)));
			const removeinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("IF")) as unknown as AnyAction)));
			const selquote = () => new Promise((resolve) => resolve(dispatch((Quotes.selectQuote("")) as unknown as AnyAction)));
			closeMenu().then(() => removequoteform()).then(() => removeinstructionform()).then(() => selquote()).then(() => navigate('/quote'));
			return;
		}
		if (loc == "/instruct") {
			const removeinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("IF")) as unknown as AnyAction)));
			const selquote = () => new Promise((resolve) => resolve(dispatch((Quotes.selectQuote("")) as unknown as AnyAction)));
			closeMenu().then(() => removeinstructionform()).then(() => selquote()).then(() => navigate('/instruct'));
			return;
		}
		closeMenu().then(() => navigate(loc));
	}

	const isLoaded = cases.isLoaded;

	return (
		<div className="NavMenu" style={{ height: uiState.menuLeft }}>
			<div style={{ height: 12 }}></div>
			<div className={(isLoaded ? (location.pathname === "/home" ? "menuItem menuSelect" : "menuItem") : "menuDisabled")} onClick={(isLoaded ? () => clickItem('/home') : undefined)}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img style={{ width: 32, height: 32, marginRight: 12 }} src={icon_home} alt='Home-Icon' />
					<div>Home</div>
				</div>
			</div>
			<div className={(isLoaded ? (location.pathname === "/hub" ? "menuItem menuSelect" : "menuItem") : "menuDisabled")} onClick={(isLoaded ? () => clickItem('/hub') : undefined)}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img style={{ width: 32, height: 32, marginRight: 12 }} src={icon_mainhub} alt='MainHub-Icon' />
					<div>Main Hub</div>
				</div>
			</div>
			<div className={((location.pathname === "/quote" && quotes.quote.quoteid === '') ? "menuItem menuSelect" : "menuItem")} onClick={() => clickItem('/quote')}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img style={{ width: 32, height: 32, marginRight: 12 }} src={icon_quote} alt='Quote-Icon' />
					<div>Get a Quote</div>
				</div>
			</div>
			<div className={(isLoaded ? (location.pathname === "/quotes" ? "menuItem menuSelect" : "menuItem") : "menuDisabled")} onClick={(isLoaded ? () => clickItem('/loadquotes') : undefined)}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img style={{ width: 32, height: 32, marginRight: 12 }} src={icon_quote} alt='Quote-Icon' />
					<div>Your Quote List</div>
				</div>
			</div>
			<div className={(isLoaded ? (location.pathname === "/instruct" ? "menuItem menuSelect" : "menuItem") : "menuDisabled")} onClick={(isLoaded ? () => clickItem('/instruct') : undefined)}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img style={{ width: 32, height: 32, marginRight: 12 }} src={icon_instruct} alt='Instruct-Icon' />
					<div>Instruct PLS</div>
				</div>
			</div>
			<div className={(isLoaded ? (location.pathname === "/wishlist" ? "menuItem menuSelect" : "menuItem") : "menuDisabled")} onClick={(isLoaded ? () => clickItem('/wishlist') : undefined)}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img style={{ width: 32, height: 32, marginRight: 12 }} src={icon_wishlist} alt='Wishlist-Icon' />
					<div>Your Wishlist</div>
				</div>
			</div>
			<div className={(isLoaded ? (location.pathname === "/analytics" ? "menuItem menuSelect" : "menuItem") : "menuDisabled")} onClick={(isLoaded ? () => clickItem('/analytics') : undefined)}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img style={{ width: 32, height: 32, marginRight: 12 }} src={icon_analytics} alt='Analytics-Icon' />
					<div>Analytics</div>
				</div>
			</div>
			<div className={(isLoaded ? (location.pathname === "/tracker-chart" ? "menuItem menuSelect" : "menuItem") : "menuDisabled")} onClick={(isLoaded ? () => clickItem('/tracker-chart') : undefined)}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img style={{ width: 32, height: 32, marginRight: 12 }} src={icon_edit_chart} alt='Analytics-Icon' />
					<div>Edit Tracker Chart</div>
				</div>
			</div>
			<div className="menuItem" onClick={() => clickItem('/logout')}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<img style={{ width: 32, height: 32, marginRight: 12 }} src={icon_logout} alt='Logout-Icon' />
					<div>Logout</div>
				</div>
			</div>
		</div>
	);
}

export default NavMenu;